module.exports = __webpack_public_path__ + "static/media/bytt-no-14.2b56c67f.mp3";